import api from './api.ts';

const base = '/auth/browser/password-recovery';

export interface RecoveryChallenge {
  challenge_id: string;
  message: string;
  retry_after_seconds: number;
}

export const requestPasswordRecovery = async (email: string): Promise<RecoveryChallenge> =>
  (await api.post(`${base}/request`, { email })).data;

export const verifyPasswordRecovery = async (challenge_id: string, code: string): Promise<{ reset_token: string }> =>
  (await api.post(`${base}/verify`, { challenge_id, code })).data;

export const resetRecoveredPassword = async (reset_token: string, new_password: string, confirm_password: string): Promise<{ message: string }> =>
  (await api.post(`${base}/reset`, { reset_token, new_password, confirm_password })).data;
